export const config = {
    project_token: '2b8c28011056389479b288962ae5ff82',
    api_secret: 'fac4cf100a6e42493d00dbe68adbdf4f',
    project_config: { debug: true, api_host: "https://api-eu.mixpanel.com" },
    platform: process.env.REACT_APP_NODE_ENV === 'production' ? 'DOT Pub' : 'DOT Pub Dev',
    sendMixPanelEvents: process.env.REACT_APP_SEND_MIXPANEL_EVENTS
}